import React, { ImgHTMLAttributes, ReactNode, useState } from "react";
import generateAssetUrl from "@utils/generateAssetUrl";

interface CustomImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrcs?: string[];
  fallback?: ReactNode;
}

export default function CustomImage({
  fallbackSrcs = [],
  fallback,
  ...props
}: CustomImageProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    if (currentIndex < fallbackSrcs.length) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      setHasError(true);
      setIsLoading(false);
    }
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  const getSource = () => {
    if (hasError) {
      return generateAssetUrl();
    } else if (currentIndex === 0) {
      return props.src;
    } else if (currentIndex - 1 < fallbackSrcs.length) {
      return fallbackSrcs[currentIndex - 1];
    } else {
      return props.src;
    }
  };

  if (hasError && fallback) {
    return fallback;
  }

  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center">
      {isLoading && (
        <div className="absolute h-full w-full animate-pulse rounded-md bg-slate-200"></div>
      )}
      <img
        {...props}
        src={getSource()}
        onError={handleError}
        onLoad={handleLoad}
        alt={props.alt}
        style={isLoading ? { display: "none" } : {}}
      />
    </div>
  );
}
